export const ACTION_ADD_NOTIFICATION = 'ACTION_ADD_NOTIFICATION';
export const ACTION_DELETE_NOTIFICATION = 'ACTION_DELETE_NOTIFICATION';

interface AddNotificationAction {
    type: typeof ACTION_ADD_NOTIFICATION;
    notification: NotificationMessage;
}

interface DeleteNotificationAction {
    type: typeof ACTION_DELETE_NOTIFICATION;
    notification: NotificationMessage;
}

export type NotificationColor = 'success' | 'info' | 'warning' | 'error' | 'alert';

// export type NotificationEmoji = { [color in NotificationColor]: string };

// export const notificationEmoji: NotificationEmoji = {
//     success: '😃',
//     info: '🤓',
//     error: '😭',
//     warning: '😫',
//     alert: '⚠️',
//     primary: '🖖'
// };

export interface NotificationMessage {
    duration?: number;
    title?: string;
    message: string;
    severity?: NotificationColor;
    variant?: string;
    emoji?: string;
}

export type NotificationState = Array<NotificationMessage>;

export const DEFAULT: NotificationState = [];
export const DEFAULT_NOTIFICATION: NotificationMessage = {
    duration: 10000,
    title: '',
    message: '',
    severity: 'success',
};

export type NotificationActionTypes = AddNotificationAction | DeleteNotificationAction;
